const translations = {
  "en": {
    "Annual": "Annual",
    "EPS": "EPS",
    "Quarterly": "Quarterly",
    "Revenue": "Revenue"
  },
  "zh-tw": {
    "Annual": "年度",
    "EPS": "EPS",
    "Quarterly": "每季",
    "Revenue": "營收"
  }
};

export default translations;
